import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e3ba658"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "personalAccountRenewal_wrap"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 1,
  class: "step_two_wrap step_wrap"
};
const _hoisted_4 = {
  key: 2,
  class: "step_three_wrap step_wrap"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  class: "process_tip"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "error_tip"
}, "注：您的账户已失效，请通过下方成功延长服务期限后使用。（操作成功后，重新登录即可正常访问、使用后台等其它功能）", -1));
const _hoisted_8 = {
  key: 1,
  class: "error_tip"
};
const _hoisted_9 = {
  key: 2,
  class: "error_tip"
};
const _hoisted_10 = {
  class: "dialog-footer"
};
import { personAccountApplyRenewal, personAccountAgreement, personAccountSendCodeMessage, personAccountInfo, personAccountTip } from '@/assets/api/personalAccountRenewal';
import mySendCodeMessageBtn from '@/components/mySendCodeMessageBtn/mySendCodeMessageBtn.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, computed, onMounted, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'personalAccountRenewal',
  setup(__props) {
    const myStore = useStore();
    const myRouter = useRouter();
    // 个人账户渠道状态，注意，这是个人账户的
    // 1 启用 -1 禁用 0 非个人
    const personalChannelState = computed(() => myStore.getters.personalChannelState);
    const stepFormRef = ref();
    // 当前的步骤
    const currentStep = ref(1);
    // 弹窗按钮
    const currentButtonText = computed(() => {
      const textMap = {
        1: '立即延长服务时间',
        2: '下一步',
        3: '同意延长服务有效期(需全部查看协议)'
      };
      return textMap[currentStep.value];
    });
    // 按钮发生点击后
    const currentButtonClick = async () => {
      if (currentStep.value == 1) {
        stepForm.value.mobile = PersonAccountInfo.value.mobile;
        currentStep.value = 2;
        return;
      }
      if (currentStep.value == 2) {
        // 这里不需要进行if判断，
        await stepFormRef.value.validate();
        const result = await handlePersonAccountAgreement();
        if (result) {
          currentStep.value = 3;
          // 下面的逻辑是，判断带有id='isBottom'的元素，是否出现在可视区域
          nextTick(() => {
            // 创建 Intersection Observer 实例
            const observer = new IntersectionObserver(handleIntersection, {
              root: null,
              // 观察器的根元素，默认为视窗
              rootMargin: '0px',
              // 根元素的边界
              threshold: 0.5 // 元素可见比例的阈值
            });
            // 要观察的目标元素
            const targetElement = document.getElementById('isBottom');
            // 开始观察目标元素
            observer.observe(targetElement);
          });
        }
        return;
      }
      if (currentStep.value == 3) {
        handlePersonAccountApplyRenewal();
        return;
      }
    };
    // 显示隐藏对话框
    const dialogVisible = ref(false);
    // 个人账户续约 - 首页提示
    const PersonAccountTip = ref('');
    // 获取步骤一的，提示信息
    const handlePersonAccountTip = async () => {
      var _data$data, _data$data$tip;
      const data = await personAccountTip();
      PersonAccountTip.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$tip = _data$data.tip) === null || _data$data$tip === void 0 ? void 0 : _data$data$tip.replace(/\n/g, '');
      // 如果是快到期了的话，会返回稻妻提示信息，然后打开弹窗，否则返回空字符串
      if (PersonAccountTip.value) {
        dialogVisible.value = true;
        handlePersonAccountInfo();
      }
    };
    handlePersonAccountTip();
    // 步骤二表单
    const stepForm = ref({
      mobile: '',
      short_message: '',
      identity_card: '',
      user_name: ''
    });
    // 表单校验规则
    const stepFormRules = {
      mobile: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }],
      short_message: [{
        required: true,
        message: '请输入手机号校验码',
        trigger: 'blur'
      }],
      identity_card: [{
        required: true,
        message: '请输入身份证号码',
        trigger: 'blur'
      }],
      user_name: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }]
    };
    // 个人账户续约 - 获取用户基本信息
    const PersonAccountInfo = ref('');
    // 是否注册
    const isRegister = ref(false);
    // 步骤二，获取个人账户信息，如果存在账户信息，表示已经实名注册过，否则为未注册
    const handlePersonAccountInfo = async () => {
      var _PersonAccountInfo$va;
      const data = await personAccountInfo();
      PersonAccountInfo.value = data.data;
      Object.assign(stepForm.value, data.data);
      if ((_PersonAccountInfo$va = PersonAccountInfo.value) !== null && _PersonAccountInfo$va !== void 0 && _PersonAccountInfo$va.identity_card) {
        isRegister.value = true;
        handlePersonAccountAgreement();
      }
    };
    // 定义接收协议的变量
    const PersonAccountAgreement = ref('');
    // 步骤三，获取协议
    const handlePersonAccountAgreement = async () => {
      const params = {
        user_name: stepForm.value.user_name,
        identity_card: stepForm.value.identity_card
      };
      const data = await personAccountAgreement(params);
      if (data.code != 200) {
        ElMessage.error(data.message);
        return false;
      }
      PersonAccountAgreement.value = data.data.agreement;
      return true;
    };
    // 步骤三，阅读协议并续约
    const handlePersonAccountApplyRenewal = async () => {
      console.log('stepForm', stepForm.value);
      const data = await personAccountApplyRenewal(stepForm.value);
      if (data.code != 200) {
        ElMessage.error(data.message);
        return false;
      }
      dialogVisible.value = false;
      if (personalChannelState.value == 1) {
        ElMessage.success('续约成功');
      }
      if (personalChannelState.value == -1) {
        ElMessageBox.confirm('账户已经续签成功，请重新登录账户！', '标题', {
          confirmButtonText: '立即登陆',
          cancelButtonText: '暂不登录',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('wp_ct-channel-token');
          localStorage.removeItem('wp_userInfo');
          myStore.commit('setUserInfo', '');
          myRouter.push('/login');
        });
      }
      return true;
    };
    // 获取验证码
    const handlePersonAccountSendCodeMessage = async () => {
      var _data$data2;
      const data = await personAccountSendCodeMessage({
        mobile: stepForm.value.mobile
      });
      if (data.code != 200) return ElMessage.error(data.message);
      // 测试环境专用
      if ((_data$data2 = data.data) !== null && _data$data2 !== void 0 && _data$data2.message) {
        stepForm.value.short_message = data.data.message;
      }
    };
    // 判断协议是否阅读到最下方
    const isBottom = ref(false);
    const handleIntersection = entries => {
      // 当元素第一次出现在可视区域中后，就不再根据是否在可视区域进行赋值了
      if (isBottom.value == true) return;
      // 回调函数处理元素交叉状态的变化
      isBottom.value = entries[0].isIntersecting;
    };
    // 过滤按钮是否禁用的条件
    const filterButtonDisabled = () => {
      if (currentStep.value == 1 || currentStep.value == 2) {
        return false;
      }
      if (currentStep.value == 3 && isBottom.value == false) {
        return true;
      }
      if (currentStep.value == 3 && isBottom.value == true) {
        return false;
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialogVisible.value = $event),
        title: "账户服务有效期延长",
        width: "600px",
        top: "5vh",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: currentButtonClick,
          disabled: filterButtonDisabled()
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(currentButtonText)), 1)]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [currentStep.value === 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "step_one_wrap step_wrap",
          innerHTML: PersonAccountTip.value
        }, null, 8, _hoisted_2)) : _createCommentVNode("", true), currentStep.value === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_form, {
          ref_key: "stepFormRef",
          ref: stepFormRef,
          model: stepForm.value,
          "label-width": "120px",
          rules: stepFormRules
        }, {
          default: _withCtx(() => [!isRegister.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "姓名",
            prop: "user_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: stepForm.value.user_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => stepForm.value.user_name = $event),
              placeholder: "请输入姓名",
              disabled: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isRegister.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "身份证号码",
            prop: "identity_card"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: stepForm.value.identity_card,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => stepForm.value.identity_card = $event),
              placeholder: "请输入身份证号码",
              maxlength: "18"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "管理员手机号",
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: stepForm.value.mobile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => stepForm.value.mobile = $event),
              style: {
                "width": "175px"
              },
              maxlength: "11",
              disabled: ""
            }, null, 8, ["modelValue"]), _createVNode(mySendCodeMessageBtn, {
              getCode: handlePersonAccountSendCodeMessage,
              delaySeconds: 60,
              uniqueKey: 20230522
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号校验码",
            prop: "short_message",
            maxlength: "6"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: stepForm.value.short_message,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => stepForm.value.short_message = $event),
              placeholder: "请输入手机号校验码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])) : _createCommentVNode("", true), currentStep.value === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
          style: {
            "height": "75vh",
            "overflow-y": "auto"
          },
          innerHTML: PersonAccountAgreement.value
        }, null, 8, _hoisted_5)])) : _createCommentVNode("", true), _createElementVNode("div", null, [currentStep.value != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "流程：授权验证（信息验证）—> ②查看并浏览服务协议。")) : _createCommentVNode("", true), _hoisted_7, isRegister.value && currentStep.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, "注：请用管理员手机号做授权校验，若因手机号问题无法校验，请联系对应业务人员客服处理。")) : _createCommentVNode("", true), !isRegister.value && currentStep.value == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "注：您的信息已失效，请进行实名认证，若无法实名校验，请联系对应业务人员客服处理。")) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};